import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  Grid, Paper, Table, TableHead, Typography,
  TableRow, TableCell, TableBody, TableContainer,
  TableSortLabel, Tooltip, Button
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'

import { withStyles } from '@material-ui/core/styles'

import { getUsersReport, setFromLink } from '../../../redux/actions'
import { setFilter, setReportsModal } from '../../../redux/actions/select'

import { defaultFilter, statusTypes, statusFilterDetails } from '../../../utils/variables'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

const tableHeaders = [
  {
    id: statusTypes.PROBLEM,
    sortOrder: 1,
    sortedAsc: 'allProblem: asc',
    sortedDesc: 'allProblem: desc'
  },
  {
    id: statusTypes.HOLD,
    sortOrder: 2,
    sortedAsc: 'allHeld: asc',
    sortedDesc: 'allHeld: desc'
  },
  {
    id: statusTypes.UNVIEWED,
    sortOrder: 3,
    sortedAsc: 'allUnviewed: asc',
    sortedDesc: 'allUnviewed: desc'
  },
  {
    id: statusTypes.NOT_A_PROBLEM,
    sortOrder: 4,
    sortedAsc: 'allNoProblem: asc',
    sortedDesc: 'allNoProblem: desc'
  },
  {
    id: statusTypes.RESOLVED,
    sortOrder: 5,
    sortedAsc: 'allResolved: asc',
    sortedDesc: 'allResolved: desc'
  }
]

/**
 * Returns users reports
 */
const UsersReport = (props) => {
  const { classes, page, rowsPerPage, usersReport, fromLink } = props

  const dispatch = useDispatch()

  const View = useSelector(state => state.userSettings.general.defaultView)
  const Filter = useSelector(state => state.selection.Filter)
  const { permissions = [] } = useSelector(state => state.auth)

  // const [page, setPage] = useState(0)
  // const [rowsPerPage, setRowsPerPage] = useState(25)

  const [selectedOrder, setSelectedOrder] = useState('allProblem: desc')

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, usersReport.length - page * rowsPerPage)

  useEffect(() => {
    (async () => {
      await dispatch(getUsersReport(Filter, selectedOrder))
    }
    )()
  }, [dispatch, Filter, selectedOrder])

  const handleUserFilter = (captureArea, user) => {
    const filter = { ...defaultFilter, captureAreas: captureArea, usernames: [user] }
    dispatch(setFilter(filter))
    if (fromLink) {
      dispatch(setFromLink(false))
    }
    dispatch(setReportsModal(false))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  const truncateText = (str, length = 15) => {
    return str.length > 15 ? str.substring(0, length) + '...' : str
  }

  const quickSort = (a, b, key) => {
    if (a[key] < b[key]) { return -1 }
    if (a[key] > b[key]) { return 1 }
    return 0
  }

  return (
    <>
      <Grid container direction='column' justify='center' style={{ minWidth: '650px' }}>
        <Grid container direction='row'>
          <Grid container item direction='column' justify='flex-end' xs={12} className={classes.tableContainer}>
            <Paper elevation={2} className={classes.tablePaper}>
              <Grid
                container
                direction='column'
                justify='center'
                className='px-3 w-100 py-3 mx-auto my-auto'
                spacing={2}
              >
                {
                  usersReport.length > 0
                    ? (
                      <>
                        <TableContainer>
                          <Table className={classes.table} size='small' aria-label='users-table'>
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  className={`${classes.tableHeadText} unselectable`}
                                  padding='none'
                                >
                                  User
                                </TableCell>

                                {tableHeaders.sort((a, b) => quickSort(a, b, 'sortOrder')).map(headerObj => {
                                  const { id, sortedAsc, sortedDesc } = headerObj
                                  const label = statusFilterDetails.find(x => x.statusValue === id)?.statusLabel || '--'
                                  const activeSorted = [sortedAsc, sortedDesc].includes(selectedOrder)
                                  return (
                                    <TableCell
                                      key={`user-report-header-cell-${id}`}
                                      className={`${classes.tableHeadText} unselectable`}
                                      align='center'
                                      style={{ cursor: 'pointer' }}
                                      padding='none'
                                    >
                                      <TableSortLabel
                                        className={activeSorted ? classes.tableHeadSortText : ''}
                                        active={activeSorted}
                                        direction={selectedOrder === sortedAsc ? 'asc' : 'desc'}
                                        onClick={(e) => {
                                          e.preventDefault()
                                          setSelectedOrder(selectedOrder === sortedDesc ? sortedAsc : sortedDesc)
                                        }}
                                      >
                                        {label}
                                      </TableSortLabel>
                                    </TableCell>
                                  )
                                })}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {usersReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, index) => (
                                <StyledTableRow key={index}>
                                  <TableCell>
                                    <LightTooltip title={user.key.length > 15 ? user.key : ''} placement='top-end' arrow>
                                      <Button
                                        className={classes.tableText}
                                        style={{ textTransform: 'none', padding: 0, justifyContent: 'start' }}
                                        onClick={(e) => { e.preventDefault(); handleUserFilter([], user.key) }}
                                      >
                                        {truncateText(user.key)}
                                      </Button>
                                    </LightTooltip>
                                  </TableCell>

                                  {statusFilterDetails.sort((a, b) => {
                                    const matchHeaderA = tableHeaders.find(obj => obj.id === a.statusValue)
                                    const matchHeaderB = tableHeaders.find(obj => obj.id === b.statusValue)
                                    return quickSort(matchHeaderA, matchHeaderB, 'sortOrder')
                                  }).map(filterObj => {
                                    const { statusValue, reportField, statusPermission } = filterObj
                                    const optionIsDisabled = Boolean(permissions && !permissions?.includes(statusPermission))
                                    return (
                                      <TableCell
                                        key={`report-status-cell-${statusValue}`}
                                        align='center'
                                      >
                                        <Tooltip arrow enterDelay={1200} enterNextDelay={1200} title={optionIsDisabled ? 'Your user role does not have access to view this status.' : ''}>
                                          <span>
                                            <Button
                                              className={classes.tableText}
                                              style={{ textTransform: 'none', padding: 0 }}
                                              onClick={(e) => { e.preventDefault(); handleUserFilter([statusValue], user.key) }}
                                              disabled={optionIsDisabled}
                                            >
                                              {user[reportField].doc_count}
                                            </Button>
                                          </span>
                                        </Tooltip>
                                      </TableCell>
                                    )
                                  })}
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    )
                    : (
                      <>
                        <Grid item container direction='row' justify='center' alignItems='center'>
                          {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                          <Paper
                            className='mx-auto'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '10vh',
                              height: '20rem',
                              width: '30rem',
                              backgroundColor: '#F5F5F5'
                            }}
                          >
                            <Grid item container direction='column' xs={12}>
                              <Grid item container direction='row' justify='center'>
                                <AnnouncementIcon
                                  style={{
                                    fontSize: '4rem',
                                    color: 'grey',
                                    marginBottom: '1rem'
                                  }}
                                />
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography
                                  style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                >
                                  No Report Found
                                </Typography>
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography>Please try changing your selection in 'My Schools'</Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </>
                    )
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(UsersReport)
